var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiStrategy = function SvgAiStrategy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#204969",
    d: "M24.89 10.5h4.394c.395 0 .716-.297.716-.664V.664C30 .298 29.68 0 29.284 0H.716C.321 0 0 .298 0 .664v26.51c0 .368.32.665.716.665h9.175v3.42c0 1.252.53 2.443 1.499 3.357A5.33 5.33 0 0 0 15 36c2.82 0 5.11-2.125 5.11-4.741v-3.42h9.174c.395 0 .716-.297.716-.664v-9.178c0-.367-.32-.665-.716-.665H24.89c-2.03 0-3.685-1.53-3.685-3.42 0-.906.38-1.764 1.074-2.415a3.87 3.87 0 0 1 2.61-1.004z"
  })));
};
export default SvgAiStrategy;